import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-12 lg:py-40">
      <Reveal className="flex flex-wrap items-end justify-between gap-8">
        <div>
          <Overline>Services & pricing</Overline>
          <h2 className="mt-6 font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tighter text-white sm:text-5xl lg:text-6xl">
            Pick your<br />level of clean.
          </h2>
        </div>
        <p className="max-w-sm text-sm leading-relaxed text-zinc-400">
          Every service includes free local pick-up and delivery within our catchment area.
          No hidden fees, ever.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-8 md:grid-cols-3 lg:gap-10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} delay={i * 0.12}>
            <div
              data-testid={`service-card-${s.id}`}
              className={`glow-card relative flex h-full flex-col border bg-carbon p-8 sm:p-10 ${
                s.popular ? "border-aqua/40" : "border-white/5"
              }`}
            >
              {s.popular && (
                <span className="absolute -top-3 left-8 bg-aqua px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-obsidian">
                  Most booked
                </span>
              )}
              <p className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">{s.tagline}</p>
              <h3 className="mt-4 font-display text-2xl font-bold uppercase tracking-tight text-white">{s.name}</h3>
              <p className="mt-6 font-display text-5xl font-extrabold tracking-tighter text-white">
                <span className="align-top text-xl text-aqua">£</span>
                {s.price}
                <span className="ml-2 font-mono text-xs font-normal uppercase tracking-[0.2em] text-zinc-500">/ pair</span>
              </p>
              <ul className="mt-8 flex-1 space-y-3">
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-3 text-sm text-zinc-300">
                    <Check size={15} className="mt-0.5 shrink-0 text-aqua" />
                    {f}
                  </li>
                ))}
              </ul>
              <Link
                to={`/book?service=${s.id}`}
                data-testid={`service-book-${s.id}`}
                className={`mt-10 block border px-6 py-3.5 text-center font-mono text-xs font-bold uppercase tracking-[0.2em] transition-colors duration-300 ${
                  s.popular
                    ? "border-aqua bg-aqua text-obsidian hover:bg-transparent hover:text-aqua"
                    : "border-white/20 text-white hover:border-aqua hover:text-aqua"
                }`}
              >
                Book {s.name}
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
